(function (Drupal) {
  Drupal.behaviors.animateElement = {
    attach(context) {
      const animateElement = document.querySelector('.numbers-cards')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateNumbers();
          }
        });
      });

      observer.observe(animateElement);

      function animateNumbers() {
        document.querySelectorAll('.number-animate').forEach( (el) => {
          const endValue = el.getAttribute('data-end-value');
          let incrementValue = el.getAttribute('data-increment');
          const durationValue = el.getAttribute('data-duration');

          if (endValue.toString().includes('.') && incrementValue == 1) {
            const exponent = endValue.toString().split('.').pop().length;
            incrementValue = 1 / Math.pow(10, exponent);
          }
          if (endValue) numberAnimation(el, endValue, incrementValue, durationValue);
        });
      }

      function formatNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      function numberAnimation(el, endValue, incrementor, duration) {
        anime({
          targets: el,
          textContent: endValue,
          round: incrementor ? 1/incrementor : 1/5,
          easing: 'easeInOutQuad',
          duration: duration ? duration : 4000,
          complete: function(anim) {
            const endValue = el.dataset.endValue;
            if (endValue >= 1000) {
              el.textContent = formatNumberWithCommas(endValue);
            }
          }
        });
      }
    },
  };
})(Drupal);
